import { createStore } from 'vuex'
import createMultiTabState from 'vuex-multi-tab-state';

const store = createStore({
    state () {
        return {
            settings:[],
            sizes:[],
            time: 0,
            showSecretAir: false,
            vmestePopupDone: false,
            promoPopupShown: false
        }
    },
    mutations: {
        addToBasket(state, offer) {
            state.settings.basket.basket.push(offer)
        },
        removeFromBasket(state, index) {
            state.settings.basket.basket.splice(index, 1)
        },
        increaseTime(state) {
            state.time++
        },
        resetTime(state) {
            state.time = 0
        },
        openSecretAir(state) {
            state.showSecretAir = true
        },
        closeSecretAir(state) {
            state.showSecretAir = false
        },
        openEmailSubscriptionAir(state) {
            state.showEmailSubscriptionAir = true
        },
        closeEmailSubscriptionAir(state) {
            state.showEmailSubscriptionAir = false
        },
        setVmestePopupDone(state) {
            state.vmestePopupDone = true
        },
        setPromoPopupShown(state) {
            state.promoPopupShown = true
        }
    },
    getters:{

    },
    plugins: [
        createMultiTabState({
            statesPaths: ['settings.basket.basket', 'time', 'showSecretAir', 'showEmailSubscriptionAir', 'vmestePopupDone', 'promoPopupShown'],
        }),
    ]
})

export default store;
